import { QUERY_KEYS } from '../../../../../consts';
import { uploadSignedFileService } from '../../../../../services';
import { getAtomWithMutation } from '../../../../../utils';

export const uploadSignedFileAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.PATIENTS.UPLOAD_SIGNED_FILE,
  mutationFn: () => uploadSignedFileService,
});
